/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Payer_Account_In_UseInputs */

const fr_api_payer_account_in_use = /** @type {(inputs: Api_Payer_Account_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce compte est utilisé par des prestataires. Choisissez un autre compte pour changer de devise.`)
};

const en_api_payer_account_in_use = /** @type {(inputs: Api_Payer_Account_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contractors use this account. Choose another account to change currency.`)
};

/**
* | output |
* | --- |
* | "Contractors use this account. Choose another account to change currency." |
*
* @param {Api_Payer_Account_In_UseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_payer_account_in_use = /** @type {((inputs?: Api_Payer_Account_In_UseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Payer_Account_In_UseInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_payer_account_in_use(inputs)
	return fr_api_payer_account_in_use(inputs)
});